// extracted by mini-css-extract-plugin
module.exports = {"ElectorListContainer":"ElectorListContainer_ElectorListContainer__3mFOC"};